// custom js for product variants

let opitons = document.querySelector('.product-form__input[index="1"]')
const inputs = opitons.querySelectorAll("input");
inputs.forEach(input => {
  input.addEventListener("change", handleInputChangeTwo);
});

function handleInputChangeTwo() {
  
let parentElement = document.getElementById('productOption-2')
setTimeout(function(){
  const firstEnabledInput = parentElement.querySelector('input:not(.disabled)');
  let labelTarget = firstEnabledInput.nextElementSibling
  console.log('labelTarget',labelTarget)
  labelTarget.click()
}, 1000)



}